/**
 * Frontend configuration
 * Values set at build time / deployment
 */

function resolveDefaultMqttUrl() {
  if (typeof window === 'undefined') {
    return 'wss://mqtt.petrovich.kww580.ru/mqtt';
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  // WebSocket — на ОТДЕЛЬНОМ хосте mqtt.* (HTTP/1.1): основной хост на HTTP/2, а
  // nginx 1.22 не умеет WS-over-HTTP/2 → WS рвётся. Так страница остаётся HTTP/2, а
  // WebSocket работает по HTTP/1.1 на mqtt.* (для одного соединения h2 ничего не даёт).
  return `${protocol}//mqtt.${window.location.host}/mqtt`;
}

function readPositiveNumber(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export const config = {
  // API base URL (relative for same-origin)
  apiUrl: '/api',

  // API request timeout + автоповтор. На iOS WebKit fetch к /api иногда зависает
  // (прерывисто, не из-за сети) — короткий таймаут + повтор обходят зависший запрос.
  apiTimeoutMs: readPositiveNumber(import.meta.env.VITE_API_TIMEOUT_MS, 12000),
  apiRetryAttempts: readPositiveNumber(import.meta.env.VITE_API_RETRY_ATTEMPTS, 3),

  // Login-хост (mTLS по SNI на том же :443): при 401 фронт уходит сюда НАВИГАЦИЕЙ за
  // клиентским сертом (iOS отдаёт серт для навигации, но не для fetch). Backend по серту
  // ставит cookie (domain=.petrovich) и редиректит на основной хост. Отдельный ХОСТ, а не
  // порт — iOS Safari не делит cookie/навигацию между портами, но cross-host переваривает.
  loginUrl: typeof window !== 'undefined'
    ? `https://secure.${window.location.hostname}/api/session/login`
    : '',

  // MQTT broker settings
  mqtt: {
    // Рубильник: VITE_MQTT_ENABLED=false полностью отключает MQTT-WSS (диагностика
    // краша вкладки Safari; состояние при этом обновляется через /api).
    enabled: import.meta.env.VITE_MQTT_ENABLED !== 'false',

    // WebSocket URL for MQTT
    url: import.meta.env.VITE_MQTT_URL || resolveDefaultMqttUrl(),
    
    // Пароля в бандле НЕТ (этап 7.4): персональные креды приходят по cookie-сессии
    // из GET /api/mqtt/credentials (см. mqtt.js obtainCredentials).

    // Topic namespace
    namespace: 'mobile_llm_chat',
    
    // Reconnect: БАЗОВАЯ задержка собственного экспоненциального backoff в mqtt.js
    // (8с → 16 → 32 → 64 → кап reconnectMaxPeriod; jitter ±20%). Редкие попытки
    // не копят недозакрытые WSS (исторический краш вкладки iOS).
    reconnectPeriod: 8000,
    reconnectMaxPeriod: 120000,
    connectTimeout: 10000,
    resumeTimeout: 5000,
    // PINGREQ каждые 30с по открытому WSS: детекция полумёртвого iOS-сокета ~45с
    // вместо ~90с (дефолт 60). Рубильник отката — вернуть 60.
    keepalive: 30,
  },

  // Модель по умолчанию НЕ хардкодится во фронте — приходит с бэка
  // (/api/models isDefault → defaultModelStore; /api/settings/app defaultModel).

  // Pagination
  messagesPageSize: 50,

  // Max images attachable to one message
  maxImagesPerMessage: 4,
};
